import * as FullStory from "@fullstory/browser";
var parentDomainAllowList = [
    "savvy.insure",
    "vinfinder",
    "printinsurancecard",
    "cdn.trellisconnect.com/assistant",
    "tscinsurance",
];
export default function initFullStory(userId) {
    var hasValidParent = parentDomainAllowList.some(function (domain) { return document.referrer.indexOf(domain) !== -1; });
    FullStory.init({
        orgId: "KSFB0",
        recordCrossDomainIFrames: hasValidParent,
        recordOnlyThisIFrame: !hasValidParent,
        devMode: process.env.NODE_ENV !== "production",
    });
    // In order to give the FS software enough time to initialize, let's wait
    // before calling identify
    setTimeout(function () {
        if (userId) {
            FullStory.identify(userId);
        }
    }, 1000);
}
